export default __webpack_public_path__ + "static/media/placeholder-silver-cover.44afa758.svg";